module.exports = "/assets/2c0f90b770bccb9641a8a443faa0b1e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CU.png
// module id = 1278
// module chunks = 0